/** Icon class helpers for event / traffic-action / announcement list items */
export function getIconFromStatus(notified: boolean, status: string): string {
  if (notified) {
    return "notified";
  }
  return status?.toString().toLowerCase();
}

export function getIconFromState(notified: boolean): string {
  if (notified) {
    return "notified";
  }
  return "new";
}
